import { Authorizations } from "~/api/types";
import { canMember } from "~/helpers/authorizations";
import { useSite } from "~/hooks/useSite";

function useSiteAuthorizations(siteId?: number | string) {
  const { data } = useSite(siteId);

  return data?.authorizations as Authorizations | undefined;
}

export function useSitePermissions(siteId?: number | string) {
  const auth = useSiteAuthorizations(siteId);

  return {
    canSoftCrawl: canMember(auth, "crawl"),
    canForceRecrawl: canMember(auth, "recrawl"),
    canAbortCrawl: canMember(auth, "abort_crawl"),
  };
}
